{
	"paths": {
		"email": "E-mail",
		"password": "Passord",
		"newPassword": "Nytt passord",
		"repeatPassword": "Gjenta passord",
		"username": "Brukernavn",
		"firstName": "Fornavn",
		"lastName": "Etternavn",
		"emailOrUsername": "E-mail eller brukernavn",
		"telephone": "Telefon"
	},
	"errors": {
		"at_least_numbers_with_value": "Må inneholde minst {{ minimum }} tall",
		"at_least_numbers_with_path": "{{ path }} må inneholde minst {{ minimum }} tall",
		"at_least_special_characters_with_value": "Må inneholde minst {{ minimum }} spesialtegn",
		"at_least_special_characters_with_path": "{{ path }} må inneholde minst {{ minimum }} spesialtegn",
		"only_letters_numbers_underscores": "Kun bokstaver, tall og understreker er tillatt"
	}
}
